import { GetServerSideProps } from 'next';
import { QueryClient } from 'react-query';
import queryString from 'query-string';
import { getCompanyOverview } from '@/services/company/company.repo';
import { withMarketplaceRedirect } from '@/services/company/company.redirect';

export const getLocationsServerSideProps: GetServerSideProps = withMarketplaceRedirect(async (ctx) => {
  const companySlug = ctx.req.headers.host?.split('.')[0];
  const { countryCode, ...params } = ctx.query as { countryCode: string };
  const queryClient = new QueryClient();

  try {
    const companyOverViewData = await queryClient.fetchQuery(
      ['getCompanyOverview', companySlug, countryCode],
      ({ queryKey }) => getCompanyOverview(queryKey[1], queryKey[2]),
    );

    const query = queryString.stringify(params);
    const queryParams = query ? `?${query}` : '';

    return {
      props: {
        companyOverview: companyOverViewData,
        companySlug,
        queryParams,
      },
    };
  } catch (e) {
    return {
      redirect: {
        permanent: false,
        destination: 'https://agendapro.com/',
      },
    };
  }
});
